<template>
  <div class="content">
    <h1 class="has-text-centered">Schutzleiter und Masse</h1>
    <div class="box is-size-7-mobile">
      <p>
          Quelle: <a href="https://de.wikipedia.org/wiki/Liste_der_Schaltzeichen_(Elektrik/Elektronik)" target="_blank">Wikipedia</a>
      </p>
      <div class="has-overflow-x-auto mb-3">
        <table class="table is-hoverable is-striped is-fullwidth">
          <thead>
            <tr>
              <th>Schaltzeichen</th>
              <th>Beschreibung</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="has-text-centered is-vcentered"><img class="max-width-150" src="@/assets/images/symbols/schutzleiter.gif"></td>
              <td class="is-vcentered">Schutzleiter</td>
            </tr>
            <tr>
              <td class="has-text-centered is-vcentered"><img class="max-width-150" src="@/assets/images/symbols/erde.svg"></td>
              <td class="is-vcentered">Erde</td>
            </tr>
            <tr>
              <td class="has-text-centered is-vcentered"><img class="max-width-150" src="@/assets/images/symbols/funktionserdung.svg"></td>
              <td class="is-vcentered">Funktionserdung, fremdspannungsarme Erde</td>
            </tr>
            <tr>
              <td class="has-text-centered is-vcentered"><img class="max-width-150" src="@/assets/images/symbols/schutzerdung.svg"></td>
              <td class="is-vcentered">Schutzerdung</td>
            </tr>
            <tr>
              <td class="has-text-centered is-vcentered"><img class="max-width-150" src="@/assets/images/symbols/masse_gehaeuse.png"></td>
              <td class="is-vcentered">Masse, Gehäuse</td>
            </tr>
            <tr>
              <td class="has-text-centered is-vcentered"><img class="max-width-150" src="@/assets/images/symbols/potentialausgleich.svg"></td>
              <td class="is-vcentered">Potentialausgleich</td>
            </tr>
            <tr>
              <td class="has-text-centered is-vcentered"><img class="max-width-150" src="@/assets/images/symbols/schutzpotentialausgleich.svg"></td>
              <td class="is-vcentered">Schutzpotentialausgleich</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'tables-protective-earth',
  metaInfo: {
    title: 'Schutzleiter & Masse Schaltzeichen Tabelle',
    meta: [
      {
        name: 'description',
        content: 'Hier findest du eine Tabelle mit Schaltzeichen für Schutzleiter und Masse.'
      }
    ]
  },
  created () {
    this.$store.commit('updateNavTitle', { title: '<span class="fas fa-angle-left"></span> Zurück', route: 'tables' })
  }
}
</script>
